export function formatPrice(price, currency = 'EUR') {
  if (price === null || price === undefined) return '—';
  const symbols = { EUR: '€', USD: '$', GBP: '£' };
  const symbol = symbols[currency] || currency;
  return `${price.toFixed(2)} ${symbol}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  return date.toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Clean a scraped card name for search — strips common prefixes,
 * set numbers, suffixes, and noise from listing titles.
 */
export function cleanCardName(name) {
  if (!name) return '';
  let c = name;
  // Remove common prefixes (English and French)
  c = c.replace(/^(pokemon\s+card|carte\s+pok[eé]mon|carte\s+pokemon|pok[eé]mon|pokemon)\s*[-:]*\s*/i, '');
  // Remove set number patterns like "123/456" or "123/SV456"
  c = c.replace(/\s*\d{1,3}\/\S{1,6}\s*/g, ' ');
  // Remove trailing parenthetical content like "(Holo)" or "(Reverse)"
  c = c.replace(/\s*\([^)]*\)\s*$/, '');
  // Remove common suffixes
  c = c.replace(/\s*[-–]\s*(reverse\s+)?holo(foil)?\s*$/i, '');
  c = c.replace(/\s*(full\s+art|alt\s+art|alternate\s+art|secret\s+rare|holo|reverse|fa|sr|sar|rrr?|me\d+\.?\d*)\s*$/i, '');
  // Remove trailing " - SetName" patterns
  c = c.replace(/\s*[-–]\s*[A-Z].*$/, '');
  // Clean up extra whitespace
  c = c.replace(/\s+/g, ' ').trim();
  return c;
}

/**
 * Build a CardMarket search URL for a card.
 * Uses only the English Pokemon name (from name_en or TCG ref).
 */
export function buildCardMarketUrl(card) {
  // name_en is pre-computed by the backend (English TCG name or French→English translation)
  const name = card.name_en || cleanCardName(card.display_name || card.card_name || '');
  return `https://www.cardmarket.com/en/Pokemon/Products/Search?searchString=${encodeURIComponent(name)}`;
}

/**
 * Build a TCGplayer search URL for a card.
 * Uses only the English Pokemon name (from name_en or TCG ref).
 */
export function buildTcgPlayerUrl(card) {
  const name = card.name_en || cleanCardName(card.display_name || card.card_name || '');
  return `https://www.tcgplayer.com/search/pokemon/product?q=${encodeURIComponent(name)}&productLineName=pokemon`;
}

export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);

  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return formatDate(dateStr);
}
